module.exports = __webpack_public_path__ + "img/MangalKeshavLogo.b35a3560.svg";